import { useState, useEffect } from 'react';

/**
 * useLanguage - 語言 Hook
 * 優先讀取 localStorage，若無則偵測瀏覽器語言
 * 修復：移除已廢棄的 navigator.userLanguage（IE Only）
 */
export function useLanguage() {
  const [language, setLanguageState] = useState(() => {
    const stored = localStorage.getItem('language');
    if (stored && ['zh', 'en'].includes(stored)) return stored;
    // navigator.language 是標準 API，所有現代瀏覽器均支援
    const browserLang = navigator.language || 'en';
    return browserLang.startsWith('zh') ? 'zh' : 'en';
  });

  const setLanguage = (lang) => {
    if (!['zh', 'en'].includes(lang)) return;
    localStorage.setItem('language', lang);
    setLanguageState(lang);
  };

  return { language, setLanguage };
}